import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ speed = 40 }) {
  const items = [
    "SEC STUDIOS",
    "SOUTH EAST COLLECTIBLES",
    "WHATNOT READY",
    "PSA · BGS · CGC",
  ];
  return (
    <div
      className="border-y border-[#27272a] py-6 bg-[#0a0a0a]"
      data-testid="editorial-marquee"
    >
      <Marquee speed={speed} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-outline text-5xl sm:text-6xl lg:text-7xl font-semibold uppercase px-8 tracking-tight">
              {t}
            </span>
            <span className="text-gold text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
